module.exports = __webpack_public_path__ + "static/media/font.cc47c77f.svg";